import * as React from 'react';
import ContentLoader from 'react-content-loader';

// Use http://danilowoz.com/create-content-loader/ to create
// custom content loader layouts easily.
const LocationCardContentLoader = (): JSX.Element => (
    <ContentLoader height={128} width={360} speed={2} color="#f3f3f3" style={{ height: '128px' }}>
        <circle cx="29" cy="28" r="12" />
        <circle cx="29" cy="65" r="12" />
        <rect x="67" y="55" rx="2" ry="2" width="70" height="20" />
        <rect x="67" y="18" rx="2" ry="2" width="70" height="20" />
    </ContentLoader>
);

export { LocationCardContentLoader };
